// src/i18n/init.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uk_common from '../locales/uk/common.json';
import en_common from '../locales/en/common.json';
import it_common from '../locales/it/common.json';
import fr_common from '../locales/fr/common.json';


const resources = {
  uk: { common: uk_common },
  en: { common: en_common },
  it: { common: it_common },
  fr: { common: fr_common },
};

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'uk',             // фактический язык синхронизируется из URL в App.js (useLangSync)
      fallbackLng: 'uk',
      defaultNS: 'common',
      ns: ['common'],
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      returnNull: false
    })
    .catch(() => {});
}

export default i18n;
